import { TRANSACTION } from '../utils/adaptiveCardActionTypes';
import { Action } from 'adaptivecards';
import { getAdMarketPublishGroupCode } from 'owa-mail-ads-shared';
import { isFeatureEnabled } from 'owa-feature-flags';
import { getCorrelationVector } from 'owa-service/lib/correlationVector';
import getUserConfiguration from 'owa-session-store/lib/actions/getUserConfiguration';
import * as React from 'react';

const BrowserCookies = require('js-cookie');
const styles = require('../styles/opayStyles.scss');

const defaultAnchorMailboxCookieName = 'DefaultAnchorMailbox';

// Todo: Use endpoints from variant config when it's ready
export const OPAY_ENDPOINTS = {
    PPE: 'https://interactive-ppe.outlook.com/ux/app',
    PROD: 'https://interactive.outlook.com/ux/app',
    DEV: 'https://opay-dev-wc-svc.cloudapp.net/ux/app',
};

export const OPAY_IFRAME_ID = 'opay_iframe';

export default class TransactionAction extends Action {
    intent: string;
    merchantId: string;
    displayId: string;
    productContext: any;
    environment?: string = 'prod';
    triggerContext: TriggerContext | null = null;

    constructor() {
        super();
        this.intent = '';
        this.merchantId = '';
        this.displayId = '';
    }

    getJsonTypeName(): string {
        return TRANSACTION;
    }

    parse(json: any): void {
        super.parse(json);
        this.isPrimary = json.isPrimary;
        if (json.initializationContext) {
            // if original card is adaptive card, read from initializationContext
            this.intent = json.initializationContext.intent;
            this.merchantId = json.initializationContext.merchantId;
            this.displayId = json.initializationContext.displayId;
            this.productContext = json.initializationContext.productContext;
            this.environment = json.initializationContext.environment;
        } else {
            // if original card is message card, read from root level
            this.intent = json.intent;
            this.merchantId = json.merchantId;
            this.displayId = json.displayId;
            this.productContext = json.productContext;
            this.environment = json.environment;
        }

        this.triggerContext = {
            MerchantId: this.merchantId,
            DisplayId: this.displayId,
            CorrelationId: getCorrelationVector(),
            Culture: getUserConfiguration().SessionSettings.UserCulture,
            Market: getAdMarketPublishGroupCode(),
            Environment: this.environment,
        };

        // in case /actions doesn't have default anchor mailbox cookie
        // add it here to avoid aea request failure
        // this is short time workaround before actions has RUM
        BrowserCookies.set(
            defaultAnchorMailboxCookieName,
            BrowserCookies.get(defaultAnchorMailboxCookieName),
            {
                path: '/actions/',
            }
        );

        // For now default anchor mailbox cookie is required in SDF in the domain doesn't have '-sdf'.
        // When opay endpoint is anonymous in WW, remove this if check
        if (isFeatureEnabled('ring-dogfood')) {
            BrowserCookies.set(
                defaultAnchorMailboxCookieName,
                BrowserCookies.get(defaultAnchorMailboxCookieName),
                {
                    path: '/opay/',
                }
            );
        }
    }

    execute(): void {
        super.execute();
        this.triggerContext.CorrelationId = getCorrelationVector();
    }

    getIFrameElement(): JSX.Element {
        const appEndpoint = isFeatureEnabled('rp-opay-modelb-endpoint')
            ? `${window.location.origin}/opay`
            : this.getSvcEndpoint();
        const encodedProductContext = encodeURIComponent(JSON.stringify(this.productContext));
        const encodedTriggerContext = encodeURIComponent(JSON.stringify(this.triggerContext));
        const iframeUrl = `${appEndpoint}/?triggerContext=${encodedTriggerContext}&productContext=${encodedProductContext}`;

        return (
            <div className={styles.opayFlexPaneContainer}>
                <iframe id={OPAY_IFRAME_ID} className={styles.opayAppIFrameStyle} src={iframeUrl} />
            </div>
        );
    }

    private getSvcEndpoint(): string {
        if (!this.environment) {
            return OPAY_ENDPOINTS.PROD;
        }

        if (this.environment.indexOf('dev') === 0) {
            return OPAY_ENDPOINTS.DEV;
        } else if (this.environment.toLowerCase() === 'ppe') {
            return OPAY_ENDPOINTS.PPE;
        } else {
            return OPAY_ENDPOINTS.PROD;
        }
    }
}

export interface TriggerContext {
    MerchantId: string;
    DisplayId: string;
    CorrelationId: string;
    Environment?: string;
    Culture?: string;
    Market?: string;
}
